import React from "react";
import { Link } from "react-router-dom";
import { ProductCard } from "../product/ProductCard";
import { ArrowRight } from "@phosphor-icons/react";

export function HomeFeaturedProducts({ featured, totalCompounds }) {
  return (
    <section className="bg-brand-surface" data-testid="home-featured">
      <div className="mps-container mps-section">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="eyebrow mb-4" data-testid="home-featured-eyebrow">Best sellers</div>
            <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-brand-navy leading-tight" data-testid="home-featured-heading">
              Best-selling peptides, on the shelf right now.
            </h2>
            <p className="mt-5 text-lg text-brand-muted leading-relaxed">
              A rotating pick of the peptides researchers order most — every listing is packed, priced, and ready to ship for research use.
            </p>
          </div>
          <Link
            to="/shop"
            data-testid="home-featured-view-all"
            className="inline-flex items-center gap-2 text-sm font-semibold text-brand-navy hover:text-brand-accent transition-colors"
          >
            View all {totalCompounds ?? ""} peptides <ArrowRight size={14} weight="bold" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {featured.slice(0, 6).map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </div>
    </section>
  );
}
